import React, { useEffect, useState, useCallback } from "react";
import { Modal, Button } from "antd";
import Wrapper from "./style";
import { CloseCircleFilled } from "@ant-design/icons";
import { customBaseUrl, httpGet, httpPost } from "../../../store/http";
import Swal from "sweetalert2";
import { hideLoader, showLoader } from "../../../utils/loader";

const SingleUserBonus = ({ showModal, hideModal, title, selectedData, className }) => {
  const [data, setData] = useState({
    tranType: "TRANSFER",
    userId: selectedData?.userId,
    tranCrncy: "NGN",
    amount: "",
    customerCreditAccount: "",
    officeDebitAccount: "",
    paymentReference: "",
    tranNarration: "",
  });
  const [walletList, setWalletList] = useState([]);
  const [officialWalletList, setOfficialWalletList] = useState([]);

  const getOfficialWallets = useCallback(async () => {
    const res = await httpGet(`${customBaseUrl.walletUrl}/api/v1/wallet/waya/official/account`);
    if (res?.status) {
      setOfficialWalletList(res.data || []);
    }
  }, []);

  const getWallets = useCallback(async () => {
    if (!selectedData?.userId) return;
    const res = await httpGet(`${customBaseUrl.walletUrl}/api/v1/wallet/account/count/${selectedData?.userId}`);
    if (res?.status) {
      setWalletList(res.data || []);
    }
  }, [selectedData?.userId]);

  useEffect(() => {
    getOfficialWallets();
    getWallets();
  }, [getOfficialWallets, getWallets]);

  useEffect(() => {
    if (showModal) {
      setData(prev => ({
        ...prev,
        userId: selectedData?.userId,
        paymentReference: `WAYA${new Date().getTime()}`
      }));
    }
  }, [showModal, selectedData]);

  const handleTransaction = async () => {
    showLoader();
    let response = await httpPost(`${customBaseUrl.logUrl}/api/v1/requestlog/create`, {
      payload: JSON.stringify(data),
      requestId: `${new Date().getTime()}`,
      requestType: "singleRefferalBonus",
      customerName: selectedData?.referralUser || selectedData?.name
    });

    hideLoader();
    if (response.status === true) {
      Swal.fire('Done', response.message, 'success');
      hideModal(false);
    } else {
      Swal.fire('Error', response.message, 'error');
    }
  };

  return (
    <Modal
      className={className}
      centered
      visible={showModal}
      onCancel={() => hideModal(false)}
      width={500}
      footer={null}
      closable={false}
      title={
        <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
          <span>{title}</span>
          <CloseCircleFilled
            style={{ cursor: "pointer", fontSize: "22px" }}
            onClick={() => hideModal(false)}
          />
        </div>
      }
      bodyStyle={{ padding: "23px 73px 44px 73px", borderRadius: "12px" }}
    >
      <Wrapper className='row g-3 needs-validation mb-2 p-3'>
        <div className="col-md-12">
          <label className='form-label'>Receiver's Id</label>
          <input
            type='text'
            className='form-control'
            readOnly
            value={selectedData?.userId || ""}
          />
        </div>
        <div className='col-md-12'>
          <label className="form-label">Amount</label>
          <input
            className='form-control'
            value={data.amount}
            onChange={(e) => setData({ ...data, amount: e.target.value })}
          />
        </div>

        <div className='col-md-12'>
          <label className='form-label'>Select Official wallet</label>
          <select
            onChange={(e) => {
              const val = e.target.value ? JSON.parse(e.target.value) : null;
              setData({ ...data, officeDebitAccount: val?.accountNo || "" });
            }}
            className='border border-dark rounded form-select'
            value={data.officeDebitAccount ? JSON.stringify(officialWalletList?.find(item => item.accountNo === data.officeDebitAccount)) : ""}
          >
            <option value='' disabled>select wallet</option>
            {officialWalletList.map((option) => (
              <option key={option.accountNo} value={JSON.stringify(option)}>
                {`${option.acct_name} - ${option.accountNo}`}
              </option>
            ))}
          </select>
        </div>

        <div className='col-md-12'>
          <label className='form-label'>Select sender's wallet</label>
          <select
            onChange={(e) => {
              const val = e.target.value ? JSON.parse(e.target.value) : null;
              setData({ ...data, customerCreditAccount: val?.accountNo || "" });
            }}
            className='border border-dark rounded form-select'
            value={data.customerCreditAccount ? JSON.stringify(walletList?.find(item => item.accountNo === data.customerCreditAccount)) : ""}
          >
            <option value='' disabled>select wallet</option>
            {walletList?.map((option) => (
              <option key={option.accountNo} value={JSON.stringify(option)}>
                {`${option.acct_name} - ${option.accountNo} - ${option?.description || ""}`}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-12">
          <label className='form-label'>Description</label>
          <input
            type='text'
            className='form-control'
            required
            onChange={(e) => setData({ ...data, tranNarration: e.target.value })}
            value={data.tranNarration}
          />
        </div>
      </Wrapper>

      <div style={{ marginTop: "10px" }} className="row">
        <div className="col-md-12 text-center">
          <Button
            type="primary"
            onClick={handleTransaction}
            style={{ background: "#FF4B01", border: "none" }}
          >
            Proceed
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SingleUserBonus;
